// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productAvailabilityModalStyles } from "@ces/App/Components/Product/ProductAvailabilityModal";
import { fontConfig } from "@ces/XDL/PreStyle/typography";
import { color, styledScrollbar, xScreen } from "@ces/XDL/Utilities";
import { LoadingOverlayStyle } from "@insite/mobius/LoadingOverlay";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

productAvailabilityModalStyles.availabilityByWarehouseModal = {
    mergeCss: true,
    cssOverrides: {
        scrim: css`
            display: flex;
            justify-content: center;
            align-items: center;
        `,
        modalContainer: css`
            height: unset;
            max-height: 80vh;
            width: 71%;
            ${xScreen("lte", "md")} {
                width: 63%;
            }
            ${xScreen("lte", "sm")} {
                width: 91%;
            }
        `,
        modalContent: css`
            ${LoadingOverlayStyle} {
                display: flex;
                flex-direction: column;
                gap: 12px;
                min-height: 100px;
            }
        `,
        modalBody: css`
            &&& {
                max-width: 100%;
            }
        `,
    },
};

productAvailabilityModalStyles.currentWarehouseInfoContainer = {
    css: css`
        display: flex;
        flex: 1;
        gap: 8px;

        ${xScreen("lte", "md")} {
            flex-direction: column;
            gap: 0;
        }
    `,
};

productAvailabilityModalStyles.inventoryInfoContainer = {
    gap: 12,
};

const _typographyStyle: any = {
    size: 16,
    lineHeight: fontConfig.lineHeight.regular,
    css: css`
        margin: 0;
    `,
};

productAvailabilityModalStyles.currentWarehouseLabel = {
    ..._typographyStyle,
    weight: fontConfig.weight.bold,
};

productAvailabilityModalStyles.currentWarehouseValue = {
    ..._typographyStyle,
};

productAvailabilityModalStyles.statusSelectionContainer = {
    width: 12,
};

productAvailabilityModalStyles.warehouseStateSelection = {
    mergeCss: true,
    cssOverrides: {
        formField: css`
            ${TypographyStyle} {
                font-size: 14px;
                line-height: 22px;
                padding: 0;
                margin-right: 8px;
            }
        `,
        formInputWrapper: css`
            &&&& {
                margin-top: 0;
                width: auto;
                && {
                    > div,
                    select {
                        width: 260px;
                        ${xScreen("lte", "md")} {
                            width: 210px;
                        }
                    }
                }
                ${xScreen("lte", "md")} {
                    flex: 1;
                    width: auto;
                    select {
                        width: 100%;
                    }
                }
            }
        `,
    },
};

productAvailabilityModalStyles.centeringWrapper = {
    css: css`
        min-height: 300px;
        display: flex;
        width: 100%;
        align-items: center;
        justify-content: center;
    `,
};

productAvailabilityModalStyles.actionButton = {
    variant: "tertiary",
    typographyProps: {
        forwardAs: "p",
        color: "text.link",
    },
    css: css`
        padding: 0;
        min-height: auto;
        border: none;
        &:not(:disabled):hover {
            ${TypographyStyle} {
                color: ${color("common.ui8")};
            }
        }
        &:disabled {
            opacity: 0.66;
        }
    `,
};

productAvailabilityModalStyles.tableContainer = {
    css: css`
        max-height: 280px;
        overflow: auto;
        width: 100%;
        ${styledScrollbar()}
    `,
};

productAvailabilityModalStyles.availabilityByWarehouseNameCell = {
    css: css`
        min-width: 310px;
        white-space: pre-wrap;
    `,
};

productAvailabilityModalStyles.notify = {
    css: css`
        margin: 0;
        max-width: 100%;
        min-width: 100%;
    `,
};
